import { createContext } from 'react';

export type ScrollablePanelContextType = {
    didScrollBottom: boolean;
    onClose(): void;
};

export const ScrollablePanelContext = createContext<ScrollablePanelContextType>(null!);
